import { render, staticRenderFns } from "./BaseTour.vue?vue&type=template&id=19c52efd&"
import script from "./BaseTour.vue?vue&type=script&lang=js&"
export * from "./BaseTour.vue?vue&type=script&lang=js&"
import style0 from "./BaseTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports